import React from 'react';
import { makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';

const useStyles = makeStyles(
  (theme) => ({
    container: {
      position: 'relative',
      marginTop: '16px',
      letterSpacing: '4px',
      fontSize: '14px',
      lineHeight: '20px',
      fontWeight: 'bold',
      color: theme.palette.$dark100,
    },
    colWid: {
      border: 'none',
      height: '2px',
      position: 'absolute',
      marginTop: '-18px',
      width: '60px',
      backgroundColor: '#E30613',
    },
  }),
  'title-message-component',
);

const TitleMessage = ({ titleName }) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <hr className={classes.colWid} />
      <span className={classes.container}>{titleName}</span>
    </div>
  );
};

TitleMessage.defaultProps = {
  titleName: '',
};

TitleMessage.propTypes = {
  titleName: PropTypes.string,
};

export default TitleMessage;